import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Define the asynchronous thunk action
export const fetchAssignList = createAsyncThunk(
    'assignedProjects/fetchAssignList', // Added a more specific action type
    async ({ userUID, page, lim }) => {

        try {
            // Correctly format the URL to include userUID
            const response = await axios.get(
                `https://us-central1-fabdiz-quote.cloudfunctions.net/api/projects/assignedClients/${userUID}?page=${page}&limit=${lim}`
            );
            console.log("Fetched data:", response.data); // Log the fetched data
            console.log("userUID sathish:", userUID);
            return response.data;
        } catch (error) {
            // Handle the error case
            console.error("Error fetching assigned list:", error);
            throw error; // Rethrow the error for the rejected case
        }
    }
);

// Create the slice
const AssignReducer = createSlice({
    name: 'assignedProjects',
    initialState: {
        data: { clients: [], currentPage: 1, hasNextPage: false },
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAssignList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAssignList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload; // Assuming the payload is in the correct format
                console.log("Redux data updated:", state.data);
            })
            .addCase(fetchAssignList.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message; // More structured error message
            });
    },
});

// Export the reducer to be used in the store
export default AssignReducer.reducer;
